import classnames from 'classnames/bind'

// Libs

// Components
import Icon from '@/assets/icons'

// Types

// Styles
import styles from './style.module.scss'
import ActionIcon from '@/components/common/ActionIcon'

const cx = classnames.bind(styles)

interface ActionProps {
  isMicEnabled: boolean
  isCameraEnabled: boolean
  isDisabledCameraSwitch: boolean
  isMultiCamera: boolean
  handleMicStatus: () => void
  handleCameraStatus: () => void
  handleCameraSwitch: () => void
}

const Action = (props: ActionProps) => {
  const { isMicEnabled, isCameraEnabled, isDisabledCameraSwitch, isMultiCamera, handleMicStatus, handleCameraStatus, handleCameraSwitch } = props

  return (
    <div className={cx('action')}>
      <div className={cx('action-icon')} onClick={handleMicStatus}>
        <ActionIcon icon={isMicEnabled ? Icon.Mic : Icon.MicOff} />
      </div>
      <div className={cx('action-icon')} onClick={handleCameraStatus}>
        <ActionIcon icon={isCameraEnabled ? Icon.Camera : Icon.CameraOff} />
      </div>
      {isMultiCamera && (
        <div className={cx('action-icon')} onClick={handleCameraSwitch}>
          <ActionIcon icon={Icon.Switch} isDisabled={isDisabledCameraSwitch} />
        </div>
      )}
    </div>
  )
}

export default Action
